import React, { useState } from 'react';

import { useBooleanState } from '@lumapps/lumx-hooks/hooks/useBooleanState';
import { useLazyLoadingProgress } from '@lumapps/lumx-suspense/hooks/useLazyLoadingProgress';

export function useLoadSlackShareDialog() {
    const [isShareToSlackDialog, openShareToSlackDialog, closeShareToSlackDialog] = useBooleanState(false);
    const [slackIsLoaded, setSlackIsLoaded] = useState(false);
    const { onComponentLoaded: onSlackLoaded } = useLazyLoadingProgress(slackIsLoaded);
    const handleOpenSlack = React.useCallback(() => {
        setSlackIsLoaded(true);
        openShareToSlackDialog();
    }, [openShareToSlackDialog]);
    return {
        slackIsLoaded,
        onSlackLoaded,
        handleOpenSlack,
        isShareToSlackDialog,
        openShareToSlackDialog,
        closeShareToSlackDialog,
    };
}
